import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './views/pages/HomePage';
import ProfilePage from './views/pages/ProfilePage';
import ScanPage from './views/pages/ScanPage';
import ResultsPage from './views/pages/ResultsPage';
import { auth } from './firebaseconfig';
import TopNav from './components/TopNav';
import './views/styles/index.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);  
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
      setLoading(false);  
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div className="app-background">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="app-background">
      <Router>
        <TopNav />
        <div className="container">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/profile"
              element={isLoggedIn ? <ProfilePage /> : <Navigate to="/" />}
            />
            <Route
              path="/scan"
              element={isLoggedIn ? <ScanPage /> : <Navigate to="/" />}
            />
            <Route
              path="/results"
              element={isLoggedIn ? <ResultsPage /> : <Navigate to="/" />}
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);